import React from 'react';
import Socials from './Socials';
import Logo  from '../img/header/logo.svg';
import MobileNav from './MobileNav';
import { Link } from 'react-router-dom';
// import Menu from './ScrollToTop';

const Header = () => {  
  return <header className='bg-[#FFFF] w-full px-[10px] z-30 h-[120px] flex items-center shadow-lg'>
    <div className='flex flex-col lg:flex-row lg:items-center w-full justify-around'>
      <Link to={'/'} className=''>
        <div>
        <img className="md:w-[390px] w-[290px]"src={Logo} alt="" />
        </div>
      </Link>
      <nav className='text-[14px] hidden xl:flex gap-x-8 font-semibold'>
        <Link
          to={'/'}
          className='text-gray-800 font-bold  hover:text-[#dbc3b4] transition text-[16px]'
          >
          Início
        </Link>
        <Link
          to={'/areasdeatuacao'}
          className='text-gray-800 font-bold hover:text-[#dbc3b4] transition text-[16px]'
        >
          Áreas de Atuação
        </Link>
        <Link
          to={'/sobremim'}
          className='text-gray-800 font-bold hover: hover:text-[#dbc3b4] transition text-[16px]'
        >
          Sobre Mim
        </Link>
        <Link
          to={'/blog'}
          className='text-gray-800 font-bold hover: hover:text-[#dbc3b4] transition text-[16px]'
        >
          Blog
        </Link>
        <Link
          to={'/contato'}
          className='text-gray-800 font-bold hover: hover:text-[#dbc3b4] transition text-[16px]'
        >
          Contato
        </Link>
      </nav>
    </div>
      <Socials />
      <MobileNav />
  </header>
};

export default Header;
